module.exports = __webpack_public_path__ + "static/media/25-to-5.3c2abd59.jpg";